import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class SentryUserService {

  setUserContext(userId: string, username: string, userGroup: string) {
    Sentry.setUser({  // ✅ Use setUser directly
      userId: userId,
      username: username
    });

    Sentry.setTag("userGroup", userGroup);  // ✅ Use setTag directly
    console.log('userDetail: ', userId, username, userGroup);
  }

  clearUserContext() {
    Sentry.setUser(null); // ✅ Clears user info
    Sentry.setContext("userGroup", null); // ✅ Clears userGroup tag
  }
}
